import { render, staticRenderFns } from "./TopPick.vue?vue&type=template&id=57672e48&"
import script from "./TopPick.vue?vue&type=script&lang=js&"
export * from "./TopPick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports